import { useEffect, useState } from "react";

import { generateMetabaseEmbedUrl } from "../helpers/metabase";

export function useMetabaseDashboard(dashboardId: number) {
  const [iframeUrl, setIframeUrl] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    generateMetabaseEmbedUrl(dashboardId)
      .then(setIframeUrl)
      .catch(() => {
        console.error("Error generating Metabase embed URL");
        setIframeUrl("");
        setLoading(false);
      });
  }, [dashboardId]);

  const onLoad = () => setLoading(false);

  return { iframeUrl, loading, onLoad };
}
